import dayjs from "dayjs";

export const getObjectDifferences = (obj1, obj2) => {
  const differences = {};

  for (const key in obj1) {
    if (Object.hasOwn(obj1, key)) {
      const val1 = obj1[key];
      const val2 = obj2[key];

      const isObject = (val) =>
        val && typeof val === "object" && !Array.isArray(val);

      if (isObject(val1) && isObject(val2)) {
        const nestedDiff = getObjectDifferences(val1, val2);
        if (Object.keys(nestedDiff).length > 0) {
          differences[key] = nestedDiff;
        }
      } else if (val1 !== val2) {
        differences[key] = val2;
      }
    }
  }

  return differences;
};

const getIsoString = (date) => dayjs(date).utc().toISOString();
export const payloadMapper = (data) => ({
  routeId: Number(data?.routeId),
  priority: Number(data?.priority),
  quantity: Number(data?.quantity),
  trees: Number(data?.trees),
  startDate: getIsoString(data?.startDate),
  dueDate: getIsoString(data?.dueDate),
});
